const ProblemSection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-pink-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
              What Happens When You're In the Middle of a Job and Your Phone Rings?
            </h2>
            
            <p className="text-xl text-gray-600 leading-relaxed">
              Right now, you could be losing sales without even knowing it. Every missed call is a lead that was ready to work with you — gone.
            </p>
            
            <div className="space-y-4">
              <div className="flex items-start gap-4 bg-white p-6 rounded-xl shadow-md">
                <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-close-circle-fill text-red-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 text-lg mb-2">A new lead calls someone else</h3>
                  <p className="text-gray-600">They won't wait. They'll move on to your competitor who answers immediately.</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4 bg-white p-6 rounded-xl shadow-md">
                <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-emotion-unhappy-fill text-orange-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 text-lg mb-2">A current client feels ignored</h3>
                  <p className="text-gray-600">Unanswered calls damage relationships and trust with existing customers.</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4 bg-white p-6 rounded-xl shadow-md">
                <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-money-dollar-circle-fill text-yellow-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 text-lg mb-2">A deal slips away</h3>
                  <p className="text-gray-600">Every missed opportunity is revenue left on the table.</p>
                </div>
              </div>
            </div>
            
            <div className="pt-4">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                How much longer can you afford to let business slip away?
              </h3>
              <a 
                href="tel:+18886009252"
                className="inline-block whitespace-nowrap px-8 py-4 bg-pink-500 hover:bg-pink-600 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer"
              >
                Call the AI Demo
              </a>
            </div>
          </div>
          
          {/* Right Visual */}
          <div className="relative">
            <div className="bg-white rounded-2xl shadow-2xl p-8">
              <div className="space-y-6">
                <div className="flex items-center justify-between pb-4 border-b border-gray-200">
                  <div className="text-sm font-semibold text-gray-500">Missed Calls Today</div>
                  <div className="text-3xl font-bold text-red-600">12</div>
                </div>
                
                <div className="space-y-3">
                  {[
                    { time: '9:23 AM', name: 'Sarah Johnson', status: 'New Lead' },
                    { time: '10:45 AM', name: 'Mike Chen', status: 'Existing Client' },
                    { time: '11:30 AM', name: 'Unknown', status: 'Potential Sale' },
                    { time: '1:15 PM', name: 'Lisa Martinez', status: 'Urgent Request' },
                    { time: '2:40 PM', name: 'David Brown', status: 'Quote Request' }
                  ].map((call, index) => (
                    <div key={index} className="flex items-center gap-4 p-4 bg-red-50 rounded-lg border border-red-200">
                      <div className="w-10 h-10 bg-red-200 rounded-full flex items-center justify-center flex-shrink-0">
                        <i className="ri-phone-fill text-red-600"></i>
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="font-semibold text-gray-900 truncate">{call.name}</div>
                        <div className="text-xs text-gray-500">{call.time}</div>
                      </div>
                      <div className="text-xs font-semibold text-red-600 whitespace-nowrap">{call.status}</div>
                    </div>
                  ))}
                </div>
                
                <div className="bg-red-100 rounded-xl p-4 text-center">
                  <div className="text-sm font-semibold text-red-800 mb-1">Estimated Lost Revenue</div>
                  <div className="text-3xl font-bold text-red-600">$4,800</div>
                  <div className="text-xs text-red-700 mt-1">Just from today's missed calls</div>
                </div>
              </div>
            </div>
            
            {/* Decorative element */}
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-red-200 rounded-full blur-3xl opacity-50"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;